//@flow
import * as React from 'react';
import { themr } from 'react-css-themr';
import defaultTheme from './CreatePjpContainer.scss';
import { translate } from 'react-i18next';
import compose from 'recompose/compose';
import TeamHomebaseSelectorModal from 'common/entity/generic/TeamHomebaseSelectorModal';
import PjpStepsContainer from 'common/entity/pjpMaster/create/PjpStepsContainer';
import queryString from 'query-string';
import { withRouter } from 'common/components/core/router';
import { connect } from 'react-redux';
import { clientIdSelector } from 'common/redux/selectors/sessionSelector';
import type { RouterHistory, Match } from 'react-router-dom';
import type { TFunction } from 'react-i18next';

import {
    teamIdQuerySelector,
    homebaseIdQuerySelector
} from 'common/redux/selectors/queryParamsSelectors';

type Props = {
    theme: Object,
    match: Match,
    history: RouterHistory,
    onCreate: ({
        clientId: string,
        homebaseId: ?string,
        teamId: ?string
    }) => void,
    reloadData: () => void,
    onCancel: () => void,
    homebaseId?: string,
    teamId?: string,
    t: TFunction,
    updatePjpLimitStatus: Function
};

class CreatePjpContainer extends React.PureComponent<Props> {
    handleCreatePjpStart = ({
        teamId,
        homebaseId
    }: {
        homebaseId?: string,
        teamId?: string
    }) => {
        const { match, history } = this.props;
        let query = {
            add: null
        };
        if (teamId) {
            query = { ...query, teamId };
        }
        if (homebaseId) {
            query = {
                ...query,
                homebaseId
            };
        }
        var path = {
            pathname: match.url,
            search: queryString.stringify(query)
        };
        history.push(path);
    };

    onCancelCreatePjp = (shouldRefresh: boolean) => {
        const { match, history, reloadData } = this.props;
        history.push(match.url);
        if (shouldRefresh) {
            reloadData(true);
        }
    };

    render() {
        const {
            theme,
            t,
            teamId,
            homebaseId,
            updatePjpLimitStatus
        } = this.props;
        return !teamId || !homebaseId ? (
            <TeamHomebaseSelectorModal
                theme={theme}
                onCreate={this.handleCreatePjpStart}
                onCancel={this.onCancelCreatePjp}
                defaultHomebaseId={homebaseId}
                defaultTeamId={teamId}
                title={t('pjpCreate.pjpForm.createPjp')}
                acceptActionLabel={t('pjpCreate.pjpForm.create')}
                subtitle={t('pjpCreate.pjpForm.createPjpSubtitle')}
            />
        ) : (
            <PjpStepsContainer
                onDismiss={this.onCancelCreatePjp}
                updatePjpLimitStatus={updatePjpLimitStatus}
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const teamId = teamIdQuerySelector(state, ownProps);
    const homebaseId = homebaseIdQuerySelector(state, ownProps);
    const clientId = clientIdSelector(state, ownProps);

    return {
        teamId,
        homebaseId,
        clientId
    };
};

const withRedux = connect(mapStateToProps);
const ThemedCreatePjpContainer = compose(
    withRouter,
    withRedux,
    translate('entityManagement'),
    themr(null, defaultTheme)
)(CreatePjpContainer);

export default ThemedCreatePjpContainer;
export {
    CreatePjpContainer as UndecoratedCreatePjpContainer,
    ThemedCreatePjpContainer as CreatePjpContainer
};
